import messages from '../assets/i18n';

const textStatusOrder = (lang, status) => {
  return (
    status && status !== undefined ?
      messages[lang].statusOrder[status.toUpperCase()] : ''
  )
}

export default textStatusOrder;